import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';
import { handleGetAdminSupplementInquiryStatuses } from '@store/features/adminSupplementInquiryStatuses/actions';
import {
  adminSupplementInquiryStatusesErrorSelector,
  adminSupplementInquiryStatusesIsLoadingSelector,
  adminSupplementInquiryStatusesIsReadySelector,
  adminSupplementInquiryStatusesSelector,
} from '@store/features/adminSupplementInquiryStatuses/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useAdminSupplementInquiryStatuses = (): IAdminSupplementInquiryStatus[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(adminSupplementInquiryStatusesSelector);
  const isLoading = useSelector(adminSupplementInquiryStatusesIsLoadingSelector);
  const isReady = useSelector(adminSupplementInquiryStatusesIsReadySelector);
  const error = useSelector(adminSupplementInquiryStatusesErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetAdminSupplementInquiryStatuses());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.adminSupplementInquiryStatusesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useAdminSupplementInquiryStatuses);
